import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { LanguageProvider, useLanguage } from './contexts/LanguageContext';
import Header from './components/Header';
import Footer from './components/Footer';
import FloatingDonateButton from './components/FloatingDonateButton';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ProgramsPage from './pages/ProgramsPage';
import PartnershipsPage from './pages/PartnershipsPage';
import ContactPage from './pages/ContactPage';
import GetInvolvedPage from './pages/GetInvolvedPage';
import MediaCenterPage from './pages/MediaCenterPage';
import AdminLoginPage from './pages/AdminLoginPage';
import AdminDashboard from './pages/AdminDashboard';
import NewsFormPage from './pages/NewsFormPage';
import './App.css';

function AppContent() {
  const { language, isRTL } = useLanguage();

  return (
    <Router>
      <div className={`App ${isRTL ? 'rtl' : 'ltr'}`} dir={isRTL ? 'rtl' : 'ltr'} lang={language}>
        <Routes>
          {/* Admin Routes (without Header/Footer) */}
          <Route path="/admin/login" element={<AdminLoginPage />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/admin/news/create" element={<NewsFormPage />} />
          <Route path="/admin/news/edit/:id" element={<NewsFormPage />} />

          {/* Public Routes (with Header/Footer) */}
          <Route path="*" element={
            <>
              <Header />
              <main className="main-content">
                <Routes>
                  <Route path="/" element={<HomePage />} />
                  <Route path="/about" element={<AboutPage />} />
                  <Route path="/programs" element={<ProgramsPage />} />
                  <Route path="/partnerships" element={<PartnershipsPage />} />
                  <Route path="/contact" element={<ContactPage />} />
                  <Route path="/get-involved" element={<GetInvolvedPage />} />
                  <Route path="/media-center" element={<MediaCenterPage />} />
                </Routes>
              </main>
              <Footer />
              <FloatingDonateButton />
            </>
          } />
        </Routes>
      </div>
    </Router>
  );
}

function App() {
  return (
    <LanguageProvider>
      <AppContent />
    </LanguageProvider>
  );
}

export default App;